<template>
<div class="chapter">
<div class="inner_page">
<p class="p3">This is for my family, friends, cats, and dogs.</p>
<p class="p4"> </p>
<p class="p4"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?50b9d6e2